<template>
  <div>
    <v-card class="mt-4">
      <v-system-bar>Button</v-system-bar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="3">
              <Markdown :value="btnText" />
              <v-btn @click="btnClick">click me</v-btn>
            </v-col>
            <v-col cols="9">
              <v-row>
                <v-col>color/variant</v-col>
                <v-col
                  v-for="variant in btnVariants"
                  :key="`btnvariant-${variant}`"
                >
                  {{ variant }}
                </v-col>
              </v-row>
              <v-row v-for="color in btnColors" :key="`btncolor-${color}`">
                <v-col class="text-right">{{ color }}</v-col>
                <v-col
                  v-for="variant in btnVariants"
                  :key="`btnvariant-${variant}${color}`"
                >
                  <Button :variant="variant" :color="color" @click="btnClick">
                    <v-icon v-if="variant == 'icon'">mdi-account-circle</v-icon
                    ><span v-else>click me</span>
                  </Button>
                </v-col>
              </v-row>
              <v-row>
                <p>{{ btnOutput }}</p>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import Button from "common/components/ui/Button.vue";

const btnText = `
variant:
- default (default)
- outlined
- text
- block
- icon

color:
- primary (default)
- success
- error
- info
- warning
- danger

`;

export default defineComponent({
  components: { Button },
  name: "Playground",
  data() {
    return {
      btnText,
      btnVariants: ["default", "text", "outlined", "icon"],
      btnColors: ["primary", "success", "error", "info", "warning", "danger"],
      btnOutput: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    btnClick(event) {
      console.log("Button clicked!", event);
      this.btnOutput += "click:" + event.timeStamp.toFixed(0) + " ";
    },
  },
});
</script>
